import { render, staticRenderFns } from "./Sklad.vue?vue&type=template&id=9e44acc2&scoped=true"
import script from "./Sklad.vue?vue&type=script&lang=js"
export * from "./Sklad.vue?vue&type=script&lang=js"
import style0 from "./Sklad.vue?vue&type=style&index=0&id=9e44acc2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9e44acc2",
  null
  
)

export default component.exports